module.exports = __webpack_public_path__ + "img/1505784350.df45e5fe.jpg";